import { render } from "./MarqueeLogoWall.vue?vue&type=template&id=3db5b1d0&scoped=true"
import script from "./MarqueeLogoWall.vue?vue&type=script&lang=js"
export * from "./MarqueeLogoWall.vue?vue&type=script&lang=js"

import "./MarqueeLogoWall.vue?vue&type=style&index=0&id=3db5b1d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db5b1d0"]])

export default __exports__